import { alpha, createTheme } from "@mui/material/styles";

const primary = "#3D7A76";
const slate = "#304153";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: primary, light: "#83BAB7", dark: "#2D5F5C", contrastText: "#FFFFFF" },
    secondary: { main: slate, contrastText: "#FFFFFF" },
    background: { default: "#F4F8F7", paper: "#FFFFFF" },
    text: { primary: slate, secondary: "#5C6F7A" },
    divider: "#D8E0E8",
    success: { main: "#6B8248" },
    warning: { main: "#C48A2A" },
    error: { main: "#B54A4A" },
    info: { main: "#4F8F8B" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    h4: { fontWeight: 700, letterSpacing: "-0.02em" },
    h5: { fontWeight: 700, letterSpacing: "-0.02em" },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage:
            "radial-gradient(1000px 520px at 8% -12%, rgba(61,122,118,0.10), transparent 55%), radial-gradient(800px 420px at 100% 0%, rgba(141,160,96,0.08), transparent 50%)",
          backgroundAttachment: "fixed",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          border: "1px solid #D8E0E8",
          boxShadow: "0 8px 24px rgba(48,65,83,0.06)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: slate,
          borderBottom: "1px solid #D8E0E8",
          boxShadow: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#E6EEED",
          borderRight: "1px solid #D8E0E8",
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#EEF4F3",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 700,
          paddingLeft: 10,
          paddingRight: 10,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          margin: "2px 8px",
          "&.Mui-selected": {
            backgroundColor: alpha(primary, 0.14),
            color: primary,
            "& .MuiListItemIcon-root": { color: primary },
          },
        },
      },
    },
  },
});
